module.exports = __webpack_public_path__ + "static/media/wholeSale.11c38f6c.jpg";